import { IDocsState } from '@/domain/docs/types'

const academyState: IDocsState = {
  isBusy: false,
  chapters: [],
  selectedChapter: null,
  selectedPage: null,
  chaptersLoaded: false,
}

export default () => academyState
